<template>
  <div class="rj-page-card">
    <div class="rj-page-card__content">
      <el-form ref="searchForm" :inline="true" class="searchBoxLine" :model="searchForm">
        <el-form-item label="项目名称:" prop="projectName">
          <el-input v-model="searchForm.projectName" placeholder="请输入项目名称" />
        </el-form-item>
        <el-form-item label="合同编号:" prop="contractNum">
          <el-input v-model="searchForm.contractNum" placeholder="请输入合同编号" @blur="searchForm.contractNum = (searchForm.contractNum || '').trim()" />
        </el-form-item>
        <el-form-item label="代理商名称:" prop="distributorName">
          <el-input v-model="searchForm.distributorName" placeholder="请输入代理商名称" />
        </el-form-item>
        <el-form-item label="外销:" prop="salesManName">
          <el-input v-model="searchForm.salesManName" placeholder="请输入外销人员姓名" />
        </el-form-item>
        <el-form-item label="合同时间:" prop="createBeginTime">
          <div class="rj-flex">
            <div class="rj-flex__item">
              <el-date-picker
                v-model="searchForm.createBeginTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              />
            </div>
            <div style="display: inline-block;width: 10px;text-align: center">
              -
            </div>
            <div class="rj-flex__item">
              <el-date-picker
                v-model="searchForm.createEndTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                :picker-options="pickerOptions"
              />
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="tableLoading" @click="doSearch">
            搜索
          </el-button>
          <el-button type="default" @click="resetForm">
            重置
          </el-button>
        </el-form-item>
      </el-form>
      <div v-loading="tableLoading" class="tableBody">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column prop="date" label="操作" width="90" align="left" fixed="left">
            <template v-slot="{row}">
              <el-button type="text" @click="goEdit(row)">
                编辑
              </el-button>
              <el-button type="text" style="padding: 2px;color: #F56C6C" @click="removeDraft(row)">
                <i class="el-icon-delete" style="font-size: 16px;" />
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="projectName" label="项目名称" align="left" min-width="330" />
          <el-table-column prop="contractNum" label="合同编号" align="left" min-width="130" />
          <el-table-column prop="contractType" label="订单分类" align="left" min-width="120" />
          <el-table-column prop="createUserName" label="创建人" align="left" width="120" />
          <el-table-column prop="createTime" label="创建时间" align="left" width="150" />
          <el-table-column prop="updateUserName" label="最后维护人" align="left" width="150" />
          <el-table-column prop="updateTime" label="最后维护时间" align="left" min-width="150" />
          <el-table-column prop="salesManName" label="外销" align="left" min-width="90" />
        </el-table>
        <div style="text-align: right;margin-top: 10px">
          <el-pagination
            :page-sizes="[10, 20, 30, 40]"
            :page-size.sync="page.pageSize"
            :current-page.sync="page.currentPage"
            layout="total, prev, pager, next, jumper,sizes"
            :total="page.total"
            hide-on-single-page
            @size-change="handerSizeChange"
            @current-change="handerCurrentChange"
          />
        </div>
        <contract-file-dialog ref="fileDialog" />
      </div>
    </div>
  </div>
</template>
<script type="es6">
import contractFileDialog from '../contract/contractFileDialog';
import { getOrdersContractList, deleteDraftContract } from '@/API';
export default {
  data () {
    return {
      pickerOptions: {
        disabledDate: (time) => {
          if (this.searchForm.createBeginTime) {
            let date = new Date(this.searchForm.createBeginTime);
            date.setDate(date.getDate() - 1);
            return time.getTime() <= date.getTime();
          }
          return false;
        }
      },
      tableData: [],
      searchForm: {
        projectName: '',
        contractNum: '',
        distributorName: '',
        salesManName: '',
        departmentName: '',
        regionName: '',
        tabType: 4,
        createBeginTime: '',
        createEndTime: ''
      },
      tableLoading: false,
      page: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }
    };
  },
  components: {
    contractFileDialog
  },
  computed: {},
  methods: {
    doSearch () {
      this.tableLoading = true;
      getOrdersContractList({
        ...this.searchForm,
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize
      }).then((res) => {
        this.tableLoading = false;
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.list;
          this.page.total = json.data.total;
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    resetForm () {
      this.$refs.searchForm.resetFields();
      this.searchForm.createEndTime = '';
      this.doSearch();
    },
    handerSizeChange (val) {
      // 改变每页条数 当前页回到第一页
      this.page.currentPage = 1;
      this.doSearch();
    },
    handerCurrentChange (val) {
      // 改变当前页
      this.doSearch();
    },
    showFile (row) {
      this.$refs.fileDialog.showFile(row.contractNum);
    },
    goEdit (row) {
      if (row.isOrderAdminCreate) {
        if (row.contractType !== '国际业务下单' && row.contractType !== '国际备件下单' && row.contractType !== '国际分销下单') {
          this.$router.push({
            name: 'orderPersionContractHandledraftsDomestic',
            params: {
              contractNum: row.contractNum
            }
          });
        } else {
          this.$router.push({
            name: 'orderPersionContractHandledraftsInternational',
            params: {
              contractNum: row.contractNum
            }
          });
        }
      } else {
        if (row.contractType === '国际业务下单' || row.contractType === '国际备件下单' || row.contractType === '国际分销下单') {
          this.$router.push({
            'name': 'orderPersionContractHandlerInternational',
            params: {
              contractNum: row.contractNum
            },
            query: { isShowInternationalService: row.civilInternational ? row.civilInternational : '0' }
          });
        } else {
          this.$router.push({
            'name': 'orderPersionContractHandlerDomestic',
            params: {
              contractNum: row.contractNum
            }
          });
        }
      }
      //  else if (row.contractType === '服务订单') {
      //     this.$router.push({
      //       'name': 'orderPersionContractHandlerService',
      //       params: {
      //         contractNum: row.contractNum
      //       }
      //     });
      //   }
    },
    removeDraft (row) {
      this.tableLoading = true;
      deleteDraftContract(row.id).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.$notify({
            title: '删除成功！',
            type: 'success'
          });
          this.doSearch();
          this.tableLoading = false;
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    }
  },
  mounted () {
    this.doSearch();
  }
};
</script>
